import { Card, CardContent, Stack, Typography, Box, Skeleton } from '@mui/material';

interface LicenseStatusCardProps {
  title: string;
  value: number | string;
  severity?: 'success' | 'warning' | 'error' | 'info';
  subtitle?: string;
  loading?: boolean;
}

const severityColors = {
  success: 'primary.main',   // azul
  warning: 'warning.main',
  error: 'error.main',
  info: 'secondary.main',    // roxo
};

export default function LicenseStatusCard({
  title,
  value,
  severity = 'info',
  subtitle,
  loading = false,
}: LicenseStatusCardProps) {
  const color = severityColors[severity];

  return (
    <Card sx={{ minWidth: 200 }}>
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="overline" color="text.secondary">
            {title}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            {loading ? (
              <Skeleton variant="text" width={60} height={40} />
            ) : (
              <Typography variant="h4" color={color} fontWeight={700}>
                {value}
              </Typography>
            )}
            {loading ? (
              <Skeleton variant="text" width={40} height={20} />
            ) : subtitle ? (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
